import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {
	expenseEventActions,
	expenseEventErrorSelector,
	expenseEventFilterSelector,
	expenseEventItemsSelector,
	expenseEventLoadingSelector,
	expenseEventPaginationSelector
} from "../expenseEventSlice";
import {
	ExpenseEventTable,
	ExpenseEventFormAddEdit
} from "../components";
import {
	expenseApi
} from "~/api";
import {
	expenseGroupActions,
	expenseGroupItemsSelector
} from "../expenseGroupSlice";

function ExpenseEvent() {

	const dispatch  = useDispatch();

	const items     = useSelector(expenseEventItemsSelector);

	const loading   = useSelector(expenseEventLoadingSelector);

	const error     = useSelector(expenseEventErrorSelector);

	const pagination = useSelector(expenseEventPaginationSelector);

	const filter    = useSelector(expenseEventFilterSelector);

	const [itemEdit, setItemEdit] = useState({});
	//Group
	const listGroup = useSelector(expenseGroupItemsSelector);

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	//Load data
	useEffect(() => {
		dispatch(expenseGroupActions.fetchData({}))
	}, []);

	useEffect(() => {
		dispatch(expenseEventActions.fetchData({
			...filter,
			detail: ['user', 'group']
		}));
	}, [filter]);

	//Show Error
	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	//Submit
	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit) {
			if (itemEdit?.id == 'undefined') {
				notification.error({message: 'Lỗi', description: 'Không có thông tin thu chi để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		let [error, response] = (isEdit) ? await handleRequest(expenseApi.eventUpdate(data)) : await handleRequest(expenseApi.eventAdd(data));
		let message = apiError(`${messageAction} thu chi thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} thu chi thành công`});
			if(!isEdit) {
				dispatch(expenseEventActions.add(response.data));
			}
			else {
				setItemEdit(response.data);
				dispatch(expenseEventActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	//Delete
	const handleDelete = async () => {
		if (itemEdit?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có thông tin thu chi để xóa'});
			return;
		}
		let [error, response] = await handleRequest(expenseApi.eventDelete(itemEdit.id));
		let message = apiError(`xóa thu chi thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `xóa thu chi thành công`});
			dispatch(expenseEventActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	//Search
	const handlePaginationChange = (page) => {
		dispatch(expenseEventActions.setFilter({...filter, page }));
	}

	return (
		<Fragment>
			<ActionBar title={'Doanh thu'}>
				<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({});handleModalOpen('addEdit')}}>Thêm mới</Button>
				<Button outline blue to="/expense">Thu chi</Button>
				<Button outline blue to="/expense/group">Loại</Button>
				<Button background blue to="/expense/event">Event</Button>
			</ActionBar>
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					{items && <ExpenseEventTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						setItemEdit={setItemEdit}
						openModal={handleModalOpen}
					/>}
				</div>
				{
					<Modal title="Thu - Chi" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
						<ExpenseEventFormAddEdit item={itemEdit} listGroup={listGroup} onHandleSubmit={handleSaveItem} />
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal title="Xóa thu chi" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
						<p>Bạn muốn xóa thu chi <b>DT{itemEdit?.id}</b>?</p>
						<div className="d-flex justify-content-end gap modal-bottom pd-1">
							<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
						</div>
					</Modal>
				}
			</div>
		</Fragment>
	)
}
export default ExpenseEvent;